import { get } from 'lodash'
import Cookies from 'js-cookie'
import jwtDecode from 'jwt-decode'
import AuthToken from '~/modules/auth/models/AuthToken'
import CurrentUser from '~/modules/auth/models/CurrentUser'
import OrganizationUsers from '~/modules/organizations/models/OrganizationUsers'
import OrganizationInvite from '~/modules/organizations/models/OrganizationInvite'
import OrganizationSearch from '~/models/directories/search/OrganizationSearch'
import EdsIitCheckbox from '~/modules/eds-iit-checkbox/models/EdsIitCheckbox'

export default {
  getCode(login) {
    return AuthToken.api().getCode(login)
  },
  authenticate({ login, code }, referralLink) {
    return AuthToken.api().getToken(login.toLowerCase(), code, referralLink)
  },
  loginById(userId) {
    return AuthToken.api().getTokenForUser(userId)
  },

  /**
   * This used for login by other user from super admin user
   */
  async loginAsOtherUser(userId) {
    if (!this.getAuthToken()) {
      return
    }
    const superAdminToken = this.getAuthToken()
    await this.loginById(userId)
    superAdminToken.userType = AuthToken.userTypes.SUPER_ADMIN
    await superAdminToken.$save()
    await Promise.all([CurrentUser.deleteAll()])
    // await superAdminToken.
  },

  /**
   * This used for super admin user
   */
  async applyAdminToken() {
    if (this.getSuperAdminAuthToken()) {
      const adminToken = this.getSuperAdminAuthToken()
      await this.logout()
      adminToken.userType = AuthToken.userTypes.USER
      await adminToken.$save()
    }
  },

  async logout(vuexStore, isTokenDead = false) {
    Cookies.remove('authorized', { domain: '.dubidoc.com.ua', secure: true, sameSite: 'None' })
    if (vuexStore) {
      vuexStore.dispatch('resetStores')
    }
    if (!isTokenDead) {
      await AuthToken.api().logout()
    }
    await Promise.all([...this.deleteEntities(), AuthToken.deleteAll()])
  },

  getAuthToken() {
    return AuthToken.query().where('userType', AuthToken.userTypes.USER).first()
  },

  replaceAuthToken(token) {
    const currentToken = this.getAuthToken()
    currentToken.$delete()
    const tokenData = jwtDecode(token)
    if (tokenData) {
      AuthToken.insert({
        data: {
          token,
          userName: tokenData.login,
          userType: AuthToken.userTypes.USER,
          createdAt: tokenData.iat,
          expiredAt: tokenData.exp
        }
      })
    }
  },

  getSuperAdminAuthToken() {
    return AuthToken.query().where('userType', AuthToken.userTypes.SUPER_ADMIN).first()
  },

  getToken() {
    const authToken = this.getAuthToken()
    return get(authToken, 'token', null)
  },

  getBearer() {
    const token = this.getToken()
    return token ? 'Bearer ' + token : null
  },

  isAuthenticated() {
    return !!this.getAuthToken()
  },

  deleteCommonEntities() {
    return [OrganizationSearch.deleteAll(), EdsIitCheckbox.deleteData()]
  },

  deleteEntities() {
    return [
      ...this.deleteCommonEntities(),
      CurrentUser.deleteAll(),
      OrganizationUsers.deleteAll(),
      OrganizationInvite.deleteAll()
    ]
  }
}
